"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var DynamicComponent_1 = require('./DynamicComponent');
var DynamicComponentModule = (function () {
    function DynamicComponentModule() {
    }
    DynamicComponentModule = __decorate([
        core_1.NgModule({
            declarations: [
                DynamicComponent_1.DynamicComponent
            ],
            exports: [
                DynamicComponent_1.DynamicComponent
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], DynamicComponentModule);
    return DynamicComponentModule;
}());
exports.DynamicComponentModule = DynamicComponentModule;
//# sourceMappingURL=DynamicComponentModule.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-dynamic-component/DynamicComponentModule.js
// module id = 602
// module chunks = 0